import React, { useState } from "react";
import { forgotPassword } from "../services/auth/auth";
import { toast } from "../components/AppToast";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        if (email) {
            e.preventDefault();
            try {
                const message = await forgotPassword(email);
                toast.success(message || "Password reset link sent.");
                setSubmitted(true);
            } catch (err) {
                toast.error(err);
            }
        }
    };

    return (
        <div className="password_container">
            <div className="card shadow">
                <h3 className="mb-4 text-center" style={{ color: "#fff" }}>
                    Forgot Password
                </h3>
                {submitted ? (
                    <div className="alert alert-success text-center" role="alert">
                        If an account with that email exists, a password reset link has been sent.
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label" style={{ color: "#ccc" }}>
                                Email address
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="Enter your email"
                            />
                            <Link to="/login" className="d-block mt-3" style={{ color: "#ccc" }}>
                                Remembered your password? Login here.
                            </Link>
                        </div>
                        <button
                            type="submit"
                            className="btn"
                        >
                            Send Reset Link
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;